<template>
  <div>
    <div class="h5 font-bold">{{ draft.subjectMatter }}</div>
    <b-row class="mt-4 mb-4">
      <b-col cols="4">
        <small>Instrument number:</small>
        <div class="h5 text-blue font-bold">{{ draft.no }}</div>
      </b-col>
      <b-col cols="4">
        <small>Type:</small>
        <div class="h5 font-bold">{{ draft.documentType }}</div>
      </b-col>
      <b-col cols="4">
        <small>Filing Date:</small>
        <div class="h5 font-bold">{{ draft.filingDate }}</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <RegisteredLegalDocument :instrument-number="draft.no || draft.instrumentNumber" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RegisteredLegalDocument
  from "@/views/home/services/registry/legal-documents/tabs/RegisteredLegalDocument.vue";

export default {
  name: "DocumentInfo",
  components: { RegisteredLegalDocument },
  props: {
    documentDetailsInfo: {}
  },
  data() {
    return {
      draft: {}
    };
  },
  mounted() {
    this.filterData();
  },
  methods: {
    filterData() {
      this.draft = this.documentDetailsInfo;
    }
  },
  watch: {
    documentDetailsInfo(data) {
      if (data) {
        this.filterData();
      }
    }
  }
};
</script>

<style scoped>
</style>
